module.exports = __webpack_public_path__ + "img/meme_17.6f71667d.jpg";